import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  useCustomCover,
  EDITOR_ELEMENTS,
  EDITOR_ELEMENT_LABEL_KEYS,
} from "../index";

export const EditorToolbar: React.FC = () => {
  const { t } = useTranslation();
  const { selectedItem, onChangeSelectedItem } = useCustomCover();

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue) {
      onChangeSelectedItem(
        EDITOR_ELEMENTS[newValue as keyof typeof EDITOR_ELEMENTS]
      );
    }
  };

  return (
    <Box display="flex" justifyContent="center">
      <ToggleButtonGroup
        value={selectedItem}
        exclusive
        onChange={handleChange}
        aria-label={t("platformCustomCovers.editor.toolbarAria")}
        size="small"
      >
        <ToggleButton value={EDITOR_ELEMENTS.title}>
          {t(EDITOR_ELEMENT_LABEL_KEYS[EDITOR_ELEMENTS.title])}
        </ToggleButton>
        <ToggleButton value={EDITOR_ELEMENTS.subTitle}>
          {t(EDITOR_ELEMENT_LABEL_KEYS[EDITOR_ELEMENTS.subTitle])}
        </ToggleButton>
        <ToggleButton value={EDITOR_ELEMENTS.buttons}>
          {t(EDITOR_ELEMENT_LABEL_KEYS[EDITOR_ELEMENTS.buttons])}
        </ToggleButton>
        <ToggleButton value={EDITOR_ELEMENTS.align}>
          {t(EDITOR_ELEMENT_LABEL_KEYS[EDITOR_ELEMENTS.align])}
        </ToggleButton>
        <ToggleButton value={EDITOR_ELEMENTS.image}>
          {t(EDITOR_ELEMENT_LABEL_KEYS[EDITOR_ELEMENTS.image])}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
